const list = ['D774','D847','F859','KD16','KR48','LK59','LY31','LY49','ME50','MP65','MY37','NG58','NG83','OC79','OC80','ON02','X615','X918',];
const gifList = []; 
const ajax_url = 'https://tool.m3guo.com/api/web/m3goods/eq-item/';
const img_src = 'https://web-resource.17m3.com/cdn/m3-eq-tip/';
const img_file = '.jpg';

const ex_data = {
    'A0059' : '可于【三英聚势】网页活动中兑换奖励',
}

export default{
    list,
    gifList,
    ajax_url,
    img_src,
    img_file,
    ex_data,
}